export {
  default as mediaRoom,
  ReactComponent as MediaRoom,
} from '@assets/icons/features-and-amenities/media-room.svg'    
